import { useEffect, useState } from 'react';

// True below the 750px phone breakpoint (design-system.md §2.3). Chakra's useBreakpointValue
// misreads the theme's mixed px/em breakpoints, so this reads the media query directly.
const QUERY = '(max-width: 749.98px)';

const useIsPhone = () => {
    const mq = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(QUERY) : null;
    const [phone, setPhone] = useState(!!mq?.matches);
    useEffect(() => {
        if (!mq) return;
        const on = (e) => setPhone(e.matches);
        mq.addEventListener?.('change', on);
        return () => mq.removeEventListener?.('change', on);
    }, [mq]);
    return phone;
};

export default useIsPhone;
